import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { maxNumberValidator } from 'src/app/core/validators/max-number-validator';
import { minNumberValidator } from 'src/app/core/validators/min-number-validator';

@Component({
  selector: 'form-field-age-range',
  templateUrl: './form-field-age-range.component.html',
  styleUrls: ['./form-field-age-range.scss'],
  standalone: false,
})
export class FormFieldAgeRangeComponent implements OnInit {
  @Input('form') input_form: FormGroup;
  @Input('groupName') input_formGroupName: string;
  @Input('controlName') input_formControlName: string;
  @Input('startRangeControlName') input_startRangeControlName: string;
  @Input('endRangeControlName') input_endRangeControlName: string;
  @Input('minlabel') min_label: string;
  @Input('maxlabel') max_label: string;
  @Input() value: number[];

  @Output('value') output_value = new EventEmitter<number[]>();

  @Output('change') output_change = new EventEmitter<number[]>();
  @Output('input') output_input = new EventEmitter<number[]>();

  txtStartRange: any;
  txtEndRange: any;
  endRage: number = 0;

  constructor() {}

  ngOnInit() {
    if (this.input_formGroupName)
      this.input_form = this.input_form.controls[
        this.input_formGroupName
      ] as FormGroup;
  }

  ngOnChanges(): void {}

  onChangeMinMaxPrice() {
    this.input_form.get(this.input_startRangeControlName).clearValidators();
    this.input_form.get(this.input_endRangeControlName).clearValidators();

    if (this.txtEndRange)
      this.input_form
        .get(this.input_startRangeControlName)
        .setValidators([
          Validators.required,
          Validators.min(5),
          maxNumberValidator(this.txtEndRange),
        ]);
    if (this.txtStartRange)
      this.input_form
        .get(this.input_endRangeControlName)
        .setValidators([
          Validators.required,
          Validators.max(100),
          minNumberValidator(this.txtStartRange),
        ]);

    this.input_form
      .get(this.input_startRangeControlName)
      .updateValueAndValidity();
    this.input_form
      .get(this.input_endRangeControlName)
      .updateValueAndValidity();

    this.emit();
  }

  emit() {
    let startRange = 0;
    if (this.txtStartRange) startRange = Number.parseInt(this.txtStartRange);
    let endRage = 100;
    if (this.txtEndRange) endRage = Number.parseInt(this.txtEndRange);
    this.value = [startRange, endRage];

    if (this.input_form != null) {
      this.input_form.get(this.input_formControlName).setValue(this.value);
    }
    this.output_value.emit(this.value);
  }
}
